import React, { useContext } from "react";
import { defineMessages, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

import { UppAuthContext } from "@app/provider";
import { routes } from "@app/routing";
import { ButtonNoShadow } from "@app/components/buttonNoShadow";

import "./billingPaymentSuccess.scss";
import SuccessInfoBox from "@app/postBill/components/successInfoBox";

const messages = defineMessages({
  billingPaymentSuccessTitle: {
    id: "billingPaymentSuccessTitle",
    defaultMessage: "Success!",
  },
  billingPaymentSuccessDescription1: {
    id: "billingPaymentSuccessDescription1",
    defaultMessage: "Thank you for updating your payment method.",
  },
  billingPaymentSuccessDescription2: {
    id: "billingPaymentSuccessDescription2",
    defaultMessage: "Future transactions will be processed accordingly.",
  },
  billingPaymentSuccessButton: {
    id: "billingPaymentSuccessButton",
    defaultMessage: "Go to Billing Center",
  },
});

const BillingPaymentSuccess: React.FC = () => {
  const intl = useIntl();
  const { profile: uppProfile } = useContext(UppAuthContext);
  const navigate = useNavigate();

  return (
    <div className="billing-payment-success">
      <div className="billing-payment-success__content">
        <SuccessInfoBox
          title={intl.formatMessage(messages.billingPaymentSuccessTitle)}
          description1={intl.formatMessage(
            messages.billingPaymentSuccessDescription1
          )}
          description2={intl.formatMessage(
            messages.billingPaymentSuccessDescription2
          )}
        />
        {uppProfile?.patientUID && (
          <ButtonNoShadow raised onClick={() => navigate(routes.billingCenter)}>
            {intl.formatMessage(messages.billingPaymentSuccessButton)}
          </ButtonNoShadow>
        )}
      </div>
    </div>
  );
};

export default BillingPaymentSuccess;
